module.exports = __webpack_public_path__ + "img/mirror09.51bce666.jpg";